export default {
  andUp: '& Up'
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/star-rating/defaultLabels.js
// module id = 706
// module chunks = 0